import classNames from 'classnames';
import React from 'react';

import {Icon} from '@udemy/icons';
import {Button} from '@udemy/react-core-components';
import {BasicPopover} from '@udemy/react-popup-components';

import styles from './demo-form-header-login.module.less';

export interface DemoFormHeaderLoginProps {
    onClick?: () => void;
    dropdownPrimaryOnClick?: () => void;
    dropdownSecondaryOnClick?: () => void;
    primaryUrl?: string;
    secondaryUrl?: string;
    primaryUrlText?: string;
    secondaryUrlText?: string;
}

export const DemoFormHeaderLogin = ({
    onClick,
    dropdownPrimaryOnClick,
    dropdownSecondaryOnClick,
    primaryUrl,
    secondaryUrl,
    primaryUrlText,
    secondaryUrlText,
}: DemoFormHeaderLoginProps) => {
    const renderPopoverContent = () => {
        return (
            <div className={styles['login-popover-text']}>
                <div className={styles['dropdown-button-text-container']}>
                    <a
                        className={classNames('ud-text-md', styles['dropdown-button-text'])}
                        href={primaryUrl}
                        target="_blank"
                        rel="noreferrer"
                        onClick={dropdownPrimaryOnClick}
                    >
                        {primaryUrlText}
                    </a>
                </div>
                <div>
                    <a
                        className={classNames('ud-text-md', styles['dropdown-button-text'])}
                        href={secondaryUrl}
                        target="_blank"
                        rel="noreferrer"
                        onClick={dropdownSecondaryOnClick}
                    >
                        {secondaryUrlText}
                    </a>
                </div>
            </div>
        );
    };
    // TODO: Ensure this is hover not click behavior
    return (
        <BasicPopover
            canToggleOnHover={false}
            data-testid="login-dropdown"
            placement="bottom-end"
            withArrow={false}
            withPadding={false}
            trigger={
                <Button udStyle="secondary" onClick={onClick}>
                    {gettext('Login')}
                    <Icon glyph="expand" label="login" />
                </Button>
            }
        >
            {renderPopoverContent()}
        </BasicPopover>
    );
};
